<template>
  <div class="sku-single" @click.stop="goDetail">
    <goodImage
      :img-url="sku.skuImg.imgUrl"
      :image-width="72"
      :custom-style="customStyle"
      :sku-img="skuImg"
    />
    <div class="info">
      <SkuHeader
        :name="sku.skuBase.skuName"
        :sku-format="sku.skuFormats.skuFormat"
      />
      <SsuInfo :ssu="ssu" :sku="sku" is-single />
    </div>
  </div>
</template>

<script>
import mixin from '../mixin'
import SkuHeader from './SkuHeader.vue'
import SsuInfo from './SsuInfo.vue'
import { nativeRoutes } from '@/utils/native_interactions/native_redirect/routes'
export default {
  components: {
    SkuHeader,
    SsuInfo
  },
  mixins: [mixin],
  data() {
    return {
      customStyle: {
        with: '1.20rem',
        height: '1.20rem',
        goodImage: {
          'border-radius': '.16rem',
          overflow: 'hidden'
        }
      }
    }
  },
  computed: {
    ssu() {
      return this.sku.ssuList[0]
    }
  },
  methods: {
    goDetail() {
      const ssu = this.ssu
      this.$track(this.$trackMap.pop.goShopDetail, {
        ssu_id: ssu.ssuId,
        sku_id: ssu.sku_id,
        pop_id: Number(this.shop.id)
      })

      const spm = 'n.314.1223.0'
      const tickReferId = `${spm}.${this.skuIndex}`

      this.$nativeRedirect(nativeRoutes.goodsDetail, {
        id: ssu.ssuId,
        tickReferId
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.sku-single {
  width: 100%;
  padding: 0.16rem 0.24rem 0.2rem 0.32rem;

  background-color: #fff;

  box-sizing: border-box;
  @include flex(row, space-between, flex-start, nowrap);
  .info {
    position: relative;

    width: 0;
    margin-left: 0.16rem;
    box-sizing: border-box;

    flex: auto;
  }
}
</style>
